module.exports = __webpack_public_path__ + "static/media/success.9afc59f2.png";